import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { MapFilterCompositionService } from '@connect-services/client/services/map-filter-composition.service';
import { RessourcesModule } from '@ressources/client/ressources.module';
import { LoadingComponent } from '@shared/client/components/loading/loading.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LoadingComponent, RessourcesModule],
    selector: 'app-composition-attribute-filter-button',
    styleUrl: './composition-attribute-filter-button.component.scss',
    templateUrl: './composition-attribute-filter-button.component.html',
})
export class CompositionAttributeFilterButtonComponent {
    protected mapFilterCompositionService = inject(MapFilterCompositionService);
}
